var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"warning-box"},[_c('i',{staticClass:"fa-regular fa-triangle-exclamation"}),(_vm.type === 'Other')?_c('span',[_vm._v(_vm._s(_vm.reference))]):_c('span',[_vm._v(" "+_vm._s(_vm.$t(`${_vm.translationKey}.${_vm.type}`, [_vm.reference]))+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }